import {fetch} from '@/utils/fetch';

/**
 *
 * @param currentPage
 * @param pageSize
 * @returns {Promise}
 */
export function getUserList(currentPage, pageSize) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/users`,
    method: 'get',
    params: {
      currentPage, pageSize,
    },
  });
}

export function findUser(id) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/users/${ id }`,
    method: 'get',
  });
}

export function saveUser(user) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/users`,
    method: 'post',
    data: user,
  });
}

export function updateUser(user) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/users`,
    method: 'patch',
    data: user,
  });
}

export function delUser(id) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/users/${ id }`,
    method: 'delete',
  });
}

export function findUserRole(userId) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/userRole/${ userId }`,
    method: 'get',
  });
}

export function saveUserRole(userId, roleIds) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/userRole/${ userId }`,
    method: 'post',
    data: {roleId: roleIds},
  });
}

export function resetPassword(id) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/reset-password/${ id }`,
    method: 'patch',
  });
}

export function updatePassword(id,pwd,newPwd) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/update-password/${ id }`,
    method: 'patch',
    params: {
      pwd, newPwd,
    },
  });
}
